var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.883 1.988a2.483 2.483 0 0 1 2.483 2.483v1.282h4.105a.6.6 0 0 1 0 1.2h-1.283v12.576a2.483 2.483 0 0 1-2.483 2.483h-9.41a2.485 2.485 0 0 1-2.483-2.483V6.952H3.53a.6.6 0 1 1 0-1.2h4.106V4.472a2.483 2.483 0 0 1 2.482-2.483zM6.011 19.53a1.284 1.284 0 0 0 1.283 1.282h9.411a1.284 1.284 0 0 0 1.284-1.282V6.952h-2.214l-.01.001H6.01zm4.107-16.341A1.284 1.284 0 0 0 8.835 4.47v1.282h6.33V4.47a1.285 1.285 0 0 0-1.282-1.283z"
  })));
};
export default SvgTrash;